(function ($) {
    "use strict";

    $(function () {


        /**
         * COOKIEEEEEEEEEEEE
         */

        /*Cookie Policy*/
        function cookiesPolicyBar() {
            // Check cookie
            if ($.cookie('futureal-cookiepolicy') != "active") $('#cookieAcceptBar').show();
            //Assign cookie on click
            $('#cookieAcceptBarConfirm').on('click', function () {
                $.cookie('futureal-cookiepolicy', 'active', {expires: 31, path: '/'});
                $('#cookieAcceptBar').fadeOut();
            });
        }

        cookiesPolicyBar();
    });


})(jQuery);


